<div class="messages-container" #messagesContainer>

    <!-- Empty state -->
    <div class="empty-state" *ngIf="!permit?.messages || permit.messages.length === 0">
        <mat-icon class="empty-icon">chat_bubble_outline</mat-icon>
        <p>{{ 'permit.manage.messages.empty' | translate }}</p>
    </div>

    <!-- Messages list -->
    <div class="messages-list" *ngIf="permit?.messages && permit.messages.length > 0">
        <ng-container *ngFor="let message of sortedMessages">

            <!-- Message bubble -->
            <div class="message-wrapper"
                 [class.agent]="isAgentMessage(message)"
                 [class.citizen]="!isAgentMessage(message)">

                <!-- Avatar -->
                <div class="avatar">
                    <ng-container *ngIf="getSenderPicture(message) as picture; else initialsAvatar">
                        <img [src]="picture" [alt]="getSenderName(message) || ((isAgentMessage(message) ? 'permit.manage.messages.agent' : 'permit.manage.messages.citizen') | translate)">
                    </ng-container>
                    <ng-template #initialsAvatar>
                        <span class="initials">{{ getInitials(message) }}</span>
                    </ng-template>
                </div>

                <div class="message-content-wrapper">
                    <!-- Author name -->
                    <div class="author-name">
                        {{ getSenderName(message) || (isAgentMessage(message) ? ('permit.manage.messages.agent' | translate) : ('permit.manage.messages.citizen' | translate)) }}
                    </div>

                    <!-- Message bubble -->
                    <div class="message-bubble">
                        <p class="message-text">{{ message.text }}</p>

                        <!-- Files -->
                        <div class="message-attachments" *ngIf="getMessageFiles(message).length > 0">
                            <div class="message-attachment" *ngFor="let file of getMessageFiles(message)">
                                <div
                                    class="message-attachment-preview"
                                    [class.image-type]="isImage(file.url)"
                                    [class.pdf-type]="isPdf(file.url)"
                                    [class.other-type]="!isImage(file.url) && !isPdf(file.url)">

                                    <img
                                        *ngIf="isImage(file.url)"
                                        [src]="file.url"
                                        [alt]="fileName(file)"
                                        class="attachment-image">

                                    <img
                                        *ngIf="isPdf(file.url)"
                                        src="assets/images/pdf-file.svg"
                                        alt="PDF"
                                        class="attachment-pdf-icon">

                                    <mat-icon *ngIf="!isImage(file.url) && !isPdf(file.url)">insert_drive_file</mat-icon>
                                </div>

                                <span class="attachment-name">{{ fileName(file) }}</span>
                            </div>
                        </div>
                    </div>

                    <!-- Timestamp -->
                    <div class="message-time">{{ message.createdAt | date:'HH:mm' }}</div>
                </div>
            </div>

        </ng-container>
    </div>

</div>

<!-- Message input -->
<div class="message-input-container">
    <form [formGroup]="messageForm" (ngSubmit)="sendMessage()" class="input-form">

        <!-- Pending attachments -->
        <div class="pending-attachments" *ngIf="pendingAttachments.length > 0">
            <div
                class="attachment-preview"
                *ngFor="let attachment of pendingAttachments; let i = index"
                [class.image-preview]="attachment.type === 'image'"
                [class.pdf-preview]="attachment.type === 'pdf'"
                [class.other-preview]="attachment.type === 'other'">

                <img
                    *ngIf="attachment.type === 'image'"
                    [src]="attachment.url"
                    alt="Preview"
                    class="preview-image">

                <img
                    *ngIf="attachment.type === 'pdf'"
                    src="assets/images/pdf-file.svg"
                    alt="PDF"
                    class="pdf-icon">

                <div *ngIf="attachment.type === 'other'" class="other-file-icon">
                    <mat-icon>insert_drive_file</mat-icon>
                </div>

                <button type="button" class="remove-btn" (click)="removeAttachment(i)">
                    <mat-icon>close</mat-icon>
                </button>
            </div>
        </div>

        <div class="input-row">
            <!-- File attachment button -->
            <input
                #fileInput
                type="file"
                multiple
                accept="image/*,.pdf,.doc,.docx"
                (change)="onNativeFileSelected($event)"
                style="display: none;">
            <button
                type="button"
                class="attach-btn"
                (click)="fileInput.click()"
                [disabled]="uploading || sending"
                [matTooltip]="'permit.manage.messages.attach_file' | translate"
                matTooltipPosition="above">
                <mat-icon>attach_file</mat-icon>
            </button>

            <!-- Text input -->
            <textarea
                formControlName="message"
                [placeholder]="'permit.manage.messages.placeholder' | translate"
                class="message-input"
                rows="1"
                [attr.disabled]="uploading ? true : null"
                (keydown.enter)="$event.preventDefault(); sendMessage()">
            </textarea>

            <!-- Send button -->
            <button
                type="submit"
                class="send-btn"
                [disabled]="messageForm.invalid || sending || uploading"
                [matTooltip]="'permit.manage.messages.send' | translate"
                matTooltipPosition="above">
                <mat-icon *ngIf="!sending && !uploading">send</mat-icon>
                <mat-spinner *ngIf="sending || uploading" diameter="20"></mat-spinner>
            </button>
        </div>

    </form>
</div>
